export default "__VITE_ASSET__BaIIS_aq__"